import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const BreadcrumbsItem = /*#__PURE__*/ memo((param)=>{
    let { children, className, prefix, suffix, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "BREADCRUMBS_ITEM",
        className: tailwindMerge("flex items-center gap-1 px-1 font-medium text-grey-9 ui2:text-grey-11", className),
        ...restOfProps,
        children: [
            !!prefix && /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: prefix
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "truncate",
                children: children
            }),
            !!suffix && /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: suffix
            })
        ]
    });
});
BreadcrumbsItem.displayName = "BreadcrumbsItem";
